import React from 'react';
import styles from './styles/Stepper.module.css';

const Stepper = ({ steps, currentStep }) => {
  return (
    <ul className={styles.stepper}>
      {steps.map((step, index) => (
        <li key={index} className={index === currentStep ? styles.active : ''}>
          <span className={styles.stepNumber}>{index + 1}</span>
        </li>
      ))}
    </ul>
  );
};

export default Stepper;
